<template>
  <div id="success">
    <div class="empty"></div>
    <span>暂无数据</span>
  </div>
</template>

<script>
  export default {
    components: {}
  };

</script>

<style lang="less" scoped>
  

  #success {
    height: 100%;
    background: #fff;
    padding-top: 200/@rem-size;
    padding-bottom: 40/@rem-size;
  }

  .empty {
    width: 460/@rem-size;
    height: 460/@rem-size;
    background: url('../../assets/images/empty-img.png');
    background-size: 100% 100%;
    margin: 0 auto;
  }

  h5 {
    font-size: 36/@rem-size;
    color: #333;
    margin-top: 24/@rem-size;
    font-weight: normal;
    text-align: center;
  }

  span {
    display: block;
    font-size: 28/@rem-size;
    text-align: center;
    margin-top: 24/@rem-size;
    color: #999;
  }

  .btn-home {
    width: 360/@rem-size;
    height: 80/@rem-size;
    text-align: center;
    line-height: 80/@rem-size;
    font-size: 36/@rem-size;
    margin: 0 auto;
    margin-top: 120/@rem-size;
    border-radius: 8/@rem-size;

    a {
      color: #fff;
    }
  }

</style>
